import React, { useEffect } from 'react'
import OktaSignIn from '@okta/okta-signin-widget'
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css'
import { OKTA_WIDGET_CONFIG } from '../../constants/okta'
import styles from './styles.module.less'

export interface OktaLoginProps {
  username: string
}

export const OktaLogin = ({ username }: OktaLoginProps) => {
  let loginContainer: any = undefined
  const widget = new OktaSignIn({
    ...OKTA_WIDGET_CONFIG,
    username: username
  })

  useEffect(() => {
    widget.renderEl({ el: loginContainer })
    return function cleanup() {
      widget.remove()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div>
      <div
        ref={(div) => {
          loginContainer = div
        }}
      />
      <div className={styles.oktaSimpleFooter}>
        <div className='brand'>Powered by Okta</div>
      </div>
    </div>
  )
}
